/** Pick "Other" in size dropdown — shows custom text field. */
export const BRICK_SIZE_OTHER = '__other__';

/** Standard brick / paver sizes used in Tanzania factories. */
export const FACTORY_BRICK_SIZE_OPTIONS = [
  { value: '230×110×75 mm', label: '6″ solid — 230×110×75 mm' },
  { value: '230×110×75 mm (hollow)', label: '6″ hollow — 230×110×75 mm' },
  { value: '230×110×65 mm', label: '5″ solid — 230×110×65 mm' },
  { value: '230×110×65 mm (hollow)', label: '5″ hollow — 230×110×65 mm' },
  { value: '290×140×90 mm', label: 'Maxi — 290×140×90 mm' },
  { value: '200×100×60 mm', label: '4″ — 200×100×60 mm' },
  { value: '200×100×80 mm', label: 'Paver — 200×100×80 mm' },
  { value: 'Standard interlocking paver', label: 'Interlocking paver (standard)' },
  { value: 'Road curb stone', label: 'Road curb stone' },
];

const PRESET_VALUES = new Set(FACTORY_BRICK_SIZE_OPTIONS.map((o) => o.value));

export function isPresetBrickSize(sizeLabel) {
  return PRESET_VALUES.has(String(sizeLabel || '').trim());
}

/** Value for &lt;select&gt;: preset string, BRICK_SIZE_OTHER, or '' if unset. */
export function brickSizeSelectValue(sizeLabel) {
  const v = String(sizeLabel || '').trim();
  if (!v) return '';
  if (isPresetBrickSize(v)) return v;
  return BRICK_SIZE_OTHER;
}
